import { render, staticRenderFns } from "./AssetManagement.vue?vue&type=template&id=63c42164&scoped=true"
import script from "./AssetManagement.vue?vue&type=script&lang=js"
export * from "./AssetManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c42164",
  null
  
)

export default component.exports